import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import ArticleHero from './components/ArticleHero';
import ArticleBody from './components/ArticleBody';
import RelatedPosts from './components/RelatedPosts';
import BottomCTA from '@/pages/blog/components/BottomCTA';
import { blogPostingJsonLd } from '@/components/feature/BlogPostingJsonLd';

const jsonLd = blogPostingJsonLd({
  headline: 'A Behind-the-Scenes Look at Pop Pro Tents: Leaders in Stretch Tent Rentals',
  description: 'Discover how Pop Pro Tents has redefined the art of stretch tent rentals, from bespoke consultation and high-quality craftsmanship to expert installation and a commitment to sustainability.',
  url: `${import.meta.env.VITE_SITE_URL || 'https://popprotents.com'}/blog/behind-the-scenes-pop-pro-tents`,
  datePublished: '2024-09-12',
  dateModified: '2026-06-29',
  authorName: 'Pop Pro Tents Team',
  keywords: ['Pop Pro Tents', 'stretch tent rental company', 'behind the scenes', 'tent installation', 'event tent experts'],
});

export default function BehindScenePopProTentsPage() {
  return (
    <div className="min-h-screen bg-white">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <Navbar />
      <main>
        <ArticleHero />
        <ArticleBody />
        <RelatedPosts />
        <BottomCTA />
      </main>
      <Footer />
    </div>
  );
}